<div class="modal fade" id="refreshDataModal" tabindex="-1" aria-labelledby="refreshDataModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="refreshDataModalLabel">
          <fa-icon [icon]="faSync" [class.fa-spin]="refreshStatus.isLoading" class="me-2"></fa-icon>
          Data Refresh
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="d-flex align-items-center">
          @if (refreshStatus.isLoading) {
          <div class="spinner-border spinner-border-sm me-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          } @if (refreshStatus.isError) {
          <div class="text-danger me-3">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          </div>
          } @if (!refreshStatus.isLoading && !refreshStatus.isError) {
          <div class="text-success me-3">
            <fa-icon [icon]="faCheckCircle"></fa-icon>
          </div>
          }
          <div class="flex-grow-1">
            <p class="mb-0" [class.text-danger]="refreshStatus.isError">{{ refreshStatus.message }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" [disabled]="refreshStatus.isLoading">
          {{ refreshStatus.isLoading ? 'Please wait...' : 'Close' }}
        </button>
      </div>
    </div>
  </div>
</div>
